import { moveToOrder } from "./moveToOrder.js";
import { cdek, mhand } from "./cdek.js";
import { deliveryOrder } from "./deliveryOrder.js";
import { orderValidateInit } from "./orderValidation.js";
import { loyalty } from "./loyalty.js";
import { initCdekDropdown } from "./cdek-dropdown.js";
import { initMapVisibilityHandlers } from "./map-visibility.js";
import { initPersonalAddressFormHandlers } from "./personal-addresses.js";
import { initPersonalAddressesDropdown } from "./personal-addresses-dropdown.js";
import { initFormValidationTrigger } from "./form-validation-trigger.js";
import { initPickupAddressHandlers } from "./pickup-address-handler.js";
import { initDropdownManager } from "./dropdown-manager.js";

function init() {
    moveToOrder();
    // cdek();
    // mhand();
    deliveryOrder();
    orderValidateInit();
    loyalty();
    initCdekDropdown();
    initMapVisibilityHandlers();
    initPersonalAddressFormHandlers();
    initPersonalAddressesDropdown();
    initFormValidationTrigger();
    initPickupAddressHandlers();
    initDropdownManager();

    try {
        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('cdek_selected_addresses');
            sessionStorage.removeItem('personal_delivery_addresses');
        });
    } catch (e) {}
}

export {
    init
}